// removed by extract-text-webpack-plugin
module.exports = {"projectView":"TAjj8Os76H-4I_WQ","noPointerEvents":"YoUkr5SvzclPQzm3","viewport":"Ady71Qgydfr93NoH","previewingNode":"_24mZaz4UypgD5hqB","dragging":"Te5HBk9jLovTovd7","emptyView":"_3wBVmqT6TMOgNIMh","caption":"lMtLa2cNhqCq8124"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/ProjectView.pcss
// module id = 504
// module chunks = 1